import { RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBoxWrap, ModalBox, PromptModal, Button } from './style';
import { undoRoofToolLines } from 'store/slices/RoofToolLinesSlice';

export default function PromtModeStrip() {
	const dispatch = useDispatch();
	// const { groundMountEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { currentSelectedLine, addGutterLine, effectedFacets } = useSelector((state: RootState) => state.roofToolLines.data);
	const textLine = addGutterLine ? 'gutter line' : currentSelectedLine?.slice(0, currentSelectedLine.length - 1);

	return (
		<ModalBoxWrap className='prompt-modalbox' >
			<ModalBox>
				<PromptModal>
					<p>
						{`You need to select a facet for this ${textLine}.`}
					</p>
					<Button
						onClick={() => {
							if (effectedFacets.length > 0) {
								dispatch(undoRoofToolLines());
							}
						}}
						className='cancel-prompt'
					>
						<svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path id="cancel-path" d="M0.947266 0.947266L14.2631 14.2631M14.2631 0.947266L0.947265 14.2631"
								stroke="var(--defaultIconColor)"
								strokeWidth="1.6"
								strokeLinecap="round" />
						</svg>
					</Button>
				</PromptModal>
			</ModalBox>
		</ModalBoxWrap>
	);
}